import { createSelector } from 'reselect';

export const initialState = {
  // Current
  currentPosition:
    window.DECKEE_CONFIG && window.DECKEE_CONFIG.estimatedUserLocation
      ? window.DECKEE_CONFIG.estimatedUserLocation
      : { lat: -33.853999, lon: 151.215121 },
  currentHeading: null, // Start as null as zero is a valid value
  currentlyOverridingPosition: false,
};

// ------------------------------------
// Constants
// ------------------------------------

const GEO_SERVICE_UPDATE_CURRENT_POSITION =
  'GEO_SERVICE_UPDATE_CURRENT_POSITION';
const GEO_SERVICE_CLEAR_OVERRIDING_POSITION =
  'GEO_SERVICE_CLEAR_OVERRIDING_POSITION';
const GEO_SERVICE_UPDATE_CURRENT_BEARING = 'GEO_SERVICE_UPDATE_CURRENT_BEARING';

// ------------------------------------
// Actions
// ------------------------------------

export function updateCurrentPosition(currentPosition, override = false) {
  return {
    type: GEO_SERVICE_UPDATE_CURRENT_POSITION,
    payload: {
      currentPosition,
      currentlyOverridingPosition: override,
    },
  };
}

export function updateCurrentHeading(currentHeading) {
  return {
    type: GEO_SERVICE_UPDATE_CURRENT_BEARING,
    payload: {
      currentHeading,
    },
  };
}

export function clearOverridingPosition() {
  return {
    type: GEO_SERVICE_CLEAR_OVERRIDING_POSITION,
    payload: {
      currentlyOverridingPosition: false,
    },
  };
}

export const actions = {
  updateCurrentPosition,
  updateCurrentHeading,
  clearOverridingPosition,
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GEO_SERVICE_UPDATE_CURRENT_POSITION]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
  [GEO_SERVICE_UPDATE_CURRENT_BEARING]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
  [GEO_SERVICE_CLEAR_OVERRIDING_POSITION]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------
export const reducer = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
};

// ------------------------------------
// Selectors
// ------------------------------------
export const selectCurrentLocation = createSelector(
  (state) => state.geoService.currentPosition.lat,
  (state) => state.geoService.currentPosition.lon,
  (latitude, longitude) => ({
    latitude,
    longitude,
  }),
);
